import { Link } from "react-router-dom";
import { LI, UL } from "../../../AbstractElements";
import { USER_SOCIAL_DATAS } from "../../../Data/Users";

const SocialMediaIcons = () => {
  return (
    <UL className="card-social simple-list d-flex flex-row">
      {USER_SOCIAL_DATAS.map((data, index) => (
        <LI key={index}>
          <Link to={data.link}>
            <i className={`fa ${data.iconClassName} me-0`}></i>
          </Link>
        </LI>
      ))}
    </UL>
  );
};

export default SocialMediaIcons;
